<script setup>
    
    import { modal_2026_ui_styles, close_button_2026_styles } from '~~/shared/utilities/ui';

    const { isLoading } = useLoadingIndicator()
    
    const { $bus } = useNuxtApp();

    const props = defineProps({
        options: Object,
    })

    const open = defineModel('open');
    const route = useRoute()
    const router = useRouter()
    
    const facets = {
        '': [],
        'sessions': ['type:Session'],
        'speakers': ['type:Speaker'],
        'posts': ['type:BlogPage'],
        'sponsors': ['type:Sponsor'],
    };

    const searchOptions = computed(() => ({
        requestOptions: {
            facetFilters: route.query.search ? facets[route.query.search || ''] : [],
        },
    }));

    const handleClose = () => {
        // Apparently we can fire too fast and miss the route query update from the middlware.
        setTimeout(() => {
            if (isLoading.value) return;
            const currentQuery = { ...route.query };
            delete currentQuery.modal;
            delete currentQuery.search;
            router.replace({ query: currentQuery });
        }, 1000);
    }

    const handleOpen = (val) => {
        if (val) {
            $bus.emit('drawer-open');
        }
        else if (!val) {
            $bus.emit('drawer-close');
            handleClose();
        }
        const hs = document.getElementById('hubspot-messages-iframe-container');
        if (hs) hs.style.display = val ? 'none' : '';
    }

    const closeSearch = () => {
        handleOpen(false);
    }


</script>
<template>
    <UModal v-model:open="open" fullscreen :dismissible="false" title="Search" :close="close_button_2026_styles" description="Search UNBOUND content" @update:open="handleOpen" :ui="modal_2026_ui_styles" class="search-modal search-modal-2026">
        <template #body>
            <div class='modal-container'>
                <div class="search-card rounded-[var(--radius)] bg-white px-5 py-6 md:px-12 md:py-12 w-full max-w-[780px] mx-auto">
                    <GlobalAlgolia @closeSearch="handleClose" :searchOptions="searchOptions" />
                </div>
            </div>
        </template>
    </UModal>
</template>

<style lang="scss">
.search-modal-2026 {
    .modal-container {
        width: 100%;
        max-width: 780px;
        margin: 0 auto;
        padding: 0.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;

    }

    .search-card {
        .search-box {
            #search-field {
                color: var(--magenta);
                border-color: var(--magenta);
                border-radius: 50px 0 0 50px;
                padding: 0.875rem 1.5rem;

                &::placeholder {
                    color: var(--dark-pink);
                }
            }

            input:-webkit-autofill {
                -webkit-box-shadow: 0 0 0 50px white inset;
                -webkit-text-fill-color: var(--magenta);
            }

            form button {
                background: var(--magenta);
                color: white;
                border-color: var(--magenta);
                border-radius: 0 50px 50px 0;
                font-family: var(--font-hubspot-serif);
                font-size: 17px;
                font-weight: 400;
                text-transform: none;
                letter-spacing: 0.34px;
                padding: 0.875rem 1.5rem;

                &:hover {
                    background: var(--orange);
                    border-color: var(--orange);
                }
            }

            h2 {
                color: var(--magenta);
                font-family: var(--font-hubspot-serif);
                font-weight: 400;
                font-size: 30px;
                line-height: 1.3;
            }

            .content {
                color: var(--magenta);
            }

            ul {
                display: flex;
                flex-direction: column;
                gap: 32px;
            }

            ul li + li {
                border: none;
                margin-top: 0;
                padding-top: 0;

                &::before {
                    display: none;
                }
            }

            ul::-webkit-scrollbar {
                background-color: var(--pink);
            }

            ul::-webkit-scrollbar-thumb {
                background-color: var(--magenta);
                border-radius: 4px;
            }
        }
    }
}
</style>